import React from 'react';
import { Box, Skeleton } from '@mui/material';

const LearningSkeleton = () => (
  <Box>
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
  </Box>
);

export default LearningSkeleton;
